import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import routeConstants from "utils/routeConstants";

import { DesktopLink, MobileLink, ArrowCircle } from "./style";

type LoginLinkProps = {
  variant: "desktop" | "mobile";
};

const LoginLink: React.FC<LoginLinkProps> = ({ variant }: LoginLinkProps) => {
  const LinkComponent = variant === "desktop" ? DesktopLink : MobileLink;

  return (
    <LinkComponent to={routeConstants.login} data-test-id="login-link">
      <ArrowCircle>
        <FontAwesomeIcon icon={faArrowRight} />
      </ArrowCircle>
      Login to Insights
    </LinkComponent>
  );
};

export default LoginLink;
